var _rect, _rect2, _path, _rect3, _path2, _path3, _g, _path4, _g2, _g3, _rect4, _rect5, _rect6, _rect7, _g4, _g5, _path5, _path6, _path7, _path8, _mask, _path9, _path10, _g6, _path11, _g7, _path12, _rect8, _g8, _path13, _g9, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginMainFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 552,
    height: 361,
    viewBox: "0 0 552 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.2637,
    height: 12.2704,
    rx: 2,
    transform: "matrix(0.0185392 -0.999828 0.999828 0.0185192 516.425 99.2516)",
    fill: "#729BEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2671,
    height: 12.2671,
    rx: 2,
    transform: "matrix(0.707298 -0.706916 0.707298 0.706916 462.656 144.799)",
    fill: "#D5E2FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520.802 211.939C521.421 211.582 522.183 211.582 522.802 211.939L528.119 215.007C528.738 215.364 529.119 216.025 529.119 216.74V222.874C529.119 223.589 528.738 224.249 528.119 224.607L522.802 227.675C522.183 228.032 521.421 228.032 520.802 227.675L515.485 224.607C514.866 224.249 514.485 223.589 514.485 222.874V216.74C514.485 216.025 514.866 215.364 515.485 215.007L520.802 211.939Z",
    fill: "#FFD24B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2671,
    height: 12.2671,
    rx: 2,
    transform: "matrix(0.707298 -0.706916 0.707298 0.706916 115.46 78.7751)",
    fill: "#FF8B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1984 142.844C29.817 142.487 30.579 142.487 31.1976 142.844L36.515 145.913C37.134 146.27 37.5154 146.93 37.5154 147.645V153.78C37.5154 154.495 37.134 155.155 36.515 155.512L31.1976 158.581C30.579 158.938 29.817 158.938 29.1984 158.581L23.881 155.512C23.2619 155.155 22.8805 154.495 22.8805 153.78V147.645C22.8805 146.93 23.2619 146.27 23.881 145.913L29.1984 142.844Z",
    fill: "#FED14B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8224 261.073C77.441 260.716 78.203 260.716 78.8216 261.073L84.139 264.141C84.7581 264.498 85.1394 265.159 85.1394 265.873V272.008C85.1394 272.723 84.7581 273.383 84.139 273.74L78.8216 276.809C78.203 277.166 77.441 277.166 76.8224 276.809L71.505 273.74C70.8859 273.383 70.5046 272.723 70.5046 272.008V265.873C70.5046 265.159 70.8859 264.498 71.505 264.141L76.8224 261.073Z",
    fill: "#51D794"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_687_9678)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.6882,
    height: 84.6425,
    rx: 20,
    transform: "matrix(0.999998 0.00207199 -0.00207423 0.999998 362.4 43.9999)",
    fill: "white",
    fillOpacity: 0.67,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.498962,
    y: 0.501035,
    width: 83.6882,
    height: 83.6425,
    rx: 19.5,
    transform: "matrix(0.999998 0.00207199 -0.00207423 0.999998 362.401 43.9989)",
    stroke: "url(#paint0_linear_687_9678)",
    shapeRendering: "crispEdges"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.761 66.6516C400.057 66.6516 396.244 70.4628 396.244 75.1641V92.189C396.244 93.7561 394.973 95.0265 393.405 95.0265C391.837 95.0265 390.566 93.7561 390.566 92.189V75.1641C390.566 67.3286 396.921 60.9766 404.761 60.9766C412.601 60.9766 418.956 67.3286 418.956 75.1641V92.189C418.956 93.7561 417.685 95.0265 416.117 95.0265C414.549 95.0265 413.278 93.7561 413.278 92.189V75.1641C413.278 70.4628 409.465 66.6516 404.761 66.6516Z",
    fill: "url(#paint1_linear_687_9678)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_687_9678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.889,
    y: 77.9998,
    width: 39.7464,
    height: 31.2124,
    rx: 4,
    fill: "#FFB7B5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.196,
    y: 78.3075,
    width: 39.131,
    height: 30.597,
    rx: 3.69231,
    stroke: "url(#paint2_linear_687_9678)",
    strokeWidth: 0.615382
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_687_9678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.9,
    y: 88.5274,
    width: 12.7227,
    height: 8.48636,
    rx: 4.24318,
    transform: "rotate(90 408.9 88.5274)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.655,
    y: 88.7722,
    width: 12.2331,
    height: 7.99684,
    rx: 3.99842,
    transform: "rotate(90 408.655 88.7722)",
    stroke: "url(#paint3_linear_687_9678)",
    strokeWidth: 0.489516
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 186.128,
    y: 53.2125,
    width: 187.412,
    height: 285.59,
    rx: 24,
    fill: "#BAE0FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 186.303,
    y: 43.9999,
    width: 187.412,
    height: 285.59,
    rx: 24,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 186.803,
    y: 44.4999,
    width: 186.412,
    height: 284.59,
    rx: 23.5,
    stroke: "#B9DDFF",
    strokeOpacity: 0.7
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 204.157,
    y: 71.091,
    width: 151.706,
    height: 231.404,
    rx: 11.5,
    fill: "#19184A",
    stroke: "url(#paint4_linear_687_9678)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_687_9678)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.008,
    cy: 164.825,
    rx: 20.8235,
    ry: 20.2341,
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.525 164.825C300.525 175.822 291.347 184.753 280.008 184.753C268.668 184.753 259.49 175.822 259.49 164.825C259.49 153.827 268.668 144.896 280.008 144.896C291.347 144.896 300.525 153.827 300.525 164.825Z",
    stroke: "url(#paint5_linear_687_9678)",
    strokeWidth: 0.611895
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_687_9678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.459 219.294C246.459 219.802 246.459 220.056 246.471 220.271C246.69 224.351 249.95 227.61 254.03 227.83C254.245 227.841 254.499 227.841 255.007 227.841L303.853 227.841C304.361 227.841 304.615 227.841 304.83 227.83C308.91 227.61 312.17 224.351 312.389 220.271C312.401 220.056 312.401 219.802 312.401 219.294C312.401 217.534 312.401 216.654 312.361 215.911C311.601 201.776 300.31 190.485 286.175 189.725C285.432 189.685 284.552 189.685 282.792 189.685C280.535 189.685 278.326 189.685 276.068 189.685C274.308 189.685 273.428 189.685 272.685 189.725C258.55 190.485 247.259 201.776 246.499 215.911C246.459 216.654 246.459 217.534 246.459 219.294Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.765 219.294C246.765 219.806 246.766 220.05 246.777 220.254C246.988 224.179 250.122 227.313 254.046 227.524C254.251 227.535 254.495 227.535 255.007 227.535L303.853 227.535C304.365 227.535 304.609 227.535 304.814 227.524C308.738 227.313 311.873 224.179 312.084 220.254C312.094 220.05 312.095 219.806 312.095 219.294C312.095 217.53 312.094 216.66 312.055 215.927C311.303 201.948 300.138 190.783 286.159 190.031C285.426 189.992 284.556 189.991 282.792 189.991L282.779 189.991L282.765 189.991L282.752 189.991L282.739 189.991L282.726 189.991L282.713 189.991L282.699 189.991L282.686 189.991L282.673 189.991L282.66 189.991L282.646 189.991L282.633 189.991L282.62 189.991L282.607 189.991L282.594 189.991L282.58 189.991L282.567 189.991L282.554 189.991L282.541 189.991L282.528 189.991L282.514 189.991L282.501 189.991L282.488 189.991L282.475 189.991L282.462 189.991L282.448 189.991L282.435 189.991L282.422 189.991L282.409 189.991L282.396 189.991L282.382 189.991L282.369 189.991L282.356 189.991L282.343 189.991L282.33 189.991L282.316 189.991L282.303 189.991L282.29 189.991L282.277 189.991L282.264 189.991L282.25 189.991L282.237 189.991L282.224 189.991L282.211 189.991L282.198 189.991L282.185 189.991L282.171 189.991L282.158 189.991L282.145 189.991L282.132 189.991L282.119 189.991L282.105 189.991L282.092 189.991L282.079 189.991L282.066 189.991L282.053 189.991L282.04 189.991L282.026 189.991L282.013 189.991L282 189.991L281.987 189.991L281.974 189.991L281.961 189.991L281.947 189.991L281.934 189.991L281.921 189.991L281.908 189.991L281.895 189.991L281.882 189.991L281.868 189.991L281.855 189.991L281.842 189.991L281.829 189.991L281.816 189.991L281.803 189.991L281.79 189.991L281.776 189.991L281.763 189.991L281.75 189.991L281.737 189.991L281.724 189.991L281.711 189.991L281.697 189.991L281.684 189.991L281.671 189.991L281.658 189.991L281.645 189.991L281.632 189.991L281.619 189.991L281.605 189.991L281.592 189.991L281.579 189.991L281.566 189.991L281.553 189.991L281.54 189.991L281.527 189.991L281.513 189.991L281.5 189.991L281.487 189.991L281.474 189.991L281.461 189.991L281.448 189.991L281.435 189.991L281.421 189.991L281.408 189.991L281.395 189.991L281.382 189.991L281.369 189.991L281.356 189.991L281.343 189.991L281.33 189.991L281.316 189.991L281.303 189.991L281.29 189.991L281.277 189.991L281.264 189.991L281.251 189.991L281.238 189.991L281.225 189.991L281.211 189.991L281.198 189.991L281.185 189.991L281.172 189.991L281.159 189.991L281.146 189.991L281.133 189.991L281.12 189.991L281.106 189.991L281.093 189.991L281.08 189.991L281.067 189.991L281.054 189.991L281.041 189.991L281.028 189.991L281.015 189.991L281.001 189.991L280.988 189.991L280.975 189.991L280.962 189.991L280.949 189.991L280.936 189.991L280.923 189.991L280.91 189.991L280.897 189.991L280.883 189.991L280.87 189.991L280.857 189.991L280.844 189.991L280.831 189.991L280.818 189.991L280.805 189.991L280.792 189.991L280.779 189.991L280.765 189.991L280.752 189.991L280.739 189.991L280.726 189.991L280.713 189.991L280.7 189.991L280.687 189.991L280.674 189.991L280.661 189.991L280.648 189.991L280.634 189.991L280.621 189.991L280.608 189.991L280.595 189.991L280.582 189.991L280.569 189.991L280.556 189.991L280.543 189.991L280.53 189.991L280.516 189.991L280.503 189.991L280.49 189.991L280.477 189.991L280.464 189.991L280.451 189.991L280.438 189.991L280.425 189.991L280.412 189.991L280.399 189.991L280.386 189.991L280.372 189.991L280.359 189.991L280.346 189.991L280.333 189.991L280.32 189.991L280.307 189.991L280.294 189.991L280.281 189.991L280.268 189.991L280.255 189.991L280.241 189.991L280.228 189.991L280.215 189.991L280.202 189.991L280.189 189.991L280.176 189.991L280.163 189.991L280.15 189.991L280.137 189.991L280.124 189.991L280.111 189.991L280.097 189.991L280.084 189.991L280.071 189.991L280.058 189.991L280.045 189.991L280.032 189.991L280.019 189.991L280.006 189.991L279.993 189.991L279.98 189.991L279.967 189.991L279.953 189.991L279.94 189.991L279.927 189.991L279.914 189.991L279.901 189.991L279.888 189.991L279.875 189.991L279.862 189.991L279.849 189.991L279.836 189.991L279.823 189.991L279.81 189.991L279.796 189.991L279.783 189.991L279.77 189.991L279.757 189.991L279.744 189.991L279.731 189.991L279.718 189.991L279.705 189.991L279.692 189.991L279.679 189.991L279.666 189.991L279.652 189.991L279.639 189.991L279.626 189.991L279.613 189.991L279.6 189.991L279.587 189.991L279.574 189.991L279.561 189.991L279.548 189.991L279.535 189.991L279.522 189.991L279.509 189.991L279.495 189.991L279.482 189.991L279.469 189.991L279.456 189.991L279.443 189.991L279.43 189.991L279.417 189.991L279.404 189.991L279.391 189.991L279.378 189.991L279.365 189.991L279.352 189.991L279.338 189.991L279.325 189.991L279.312 189.991L279.299 189.991L279.286 189.991L279.273 189.991L279.26 189.991L279.247 189.991L279.234 189.991L279.221 189.991L279.208 189.991L279.194 189.991L279.181 189.991L279.168 189.991L279.155 189.991L279.142 189.991L279.129 189.991L279.116 189.991L279.103 189.991L279.09 189.991L279.077 189.991L279.064 189.991L279.051 189.991L279.037 189.991L279.024 189.991L279.011 189.991L278.998 189.991L278.985 189.991L278.972 189.991L278.959 189.991L278.946 189.991L278.933 189.991L278.92 189.991L278.907 189.991L278.893 189.991L278.88 189.991L278.867 189.991L278.854 189.991L278.841 189.991L278.828 189.991L278.815 189.991L278.802 189.991L278.789 189.991L278.776 189.991L278.763 189.991L278.749 189.991L278.736 189.991L278.723 189.991L278.71 189.991L278.697 189.991L278.684 189.991L278.671 189.991L278.658 189.991L278.645 189.991L278.632 189.991L278.619 189.991L278.605 189.991L278.592 189.991L278.579 189.991L278.566 189.991L278.553 189.991L278.54 189.991L278.527 189.991L278.514 189.991L278.501 189.991L278.488 189.991L278.475 189.991L278.461 189.991L278.448 189.991L278.435 189.991L278.422 189.991L278.409 189.991L278.396 189.991L278.383 189.991L278.37 189.991L278.357 189.991L278.344 189.991L278.33 189.991L278.317 189.991L278.304 189.991L278.291 189.991L278.278 189.991L278.265 189.991L278.252 189.991L278.239 189.991L278.226 189.991L278.213 189.991L278.199 189.991L278.186 189.991L278.173 189.991L278.16 189.991L278.147 189.991L278.134 189.991L278.121 189.991L278.108 189.991L278.095 189.991L278.081 189.991L278.068 189.991L278.055 189.991L278.042 189.991L278.029 189.991L278.016 189.991L278.003 189.991L277.99 189.991L277.977 189.991L277.963 189.991L277.95 189.991L277.937 189.991L277.924 189.991L277.911 189.991L277.898 189.991L277.885 189.991L277.872 189.991L277.859 189.991L277.845 189.991L277.832 189.991L277.819 189.991L277.806 189.991L277.793 189.991L277.78 189.991L277.767 189.991L277.754 189.991L277.74 189.991L277.727 189.991L277.714 189.991L277.701 189.991L277.688 189.991L277.675 189.991L277.662 189.991L277.649 189.991L277.636 189.991L277.622 189.991L277.609 189.991L277.596 189.991L277.583 189.991L277.57 189.991L277.557 189.991L277.544 189.991L277.53 189.991L277.517 189.991L277.504 189.991L277.491 189.991L277.478 189.991L277.465 189.991L277.452 189.991L277.439 189.991L277.425 189.991L277.412 189.991L277.399 189.991L277.386 189.991L277.373 189.991L277.36 189.991L277.347 189.991L277.333 189.991L277.32 189.991L277.307 189.991L277.294 189.991L277.281 189.991L277.268 189.991L277.255 189.991L277.241 189.991L277.228 189.991L277.215 189.991L277.202 189.991L277.189 189.991L277.176 189.991L277.163 189.991L277.149 189.991L277.136 189.991L277.123 189.991L277.11 189.991L277.097 189.991L277.084 189.991L277.071 189.991L277.057 189.991L277.044 189.991L277.031 189.991L277.018 189.991L277.005 189.991L276.992 189.991L276.978 189.991L276.965 189.991L276.952 189.991L276.939 189.991L276.926 189.991L276.913 189.991L276.899 189.991L276.886 189.991L276.873 189.991L276.86 189.991L276.847 189.991L276.834 189.991L276.82 189.991L276.807 189.991L276.794 189.991L276.781 189.991L276.768 189.991L276.755 189.991L276.741 189.991L276.728 189.991L276.715 189.991L276.702 189.991L276.689 189.991L276.675 189.991L276.662 189.991L276.649 189.991L276.636 189.991L276.623 189.991L276.61 189.991L276.596 189.991L276.583 189.991L276.57 189.991L276.557 189.991L276.544 189.991L276.53 189.991L276.517 189.991L276.504 189.991L276.491 189.991L276.478 189.991L276.464 189.991L276.451 189.991L276.438 189.991L276.425 189.991L276.412 189.991L276.398 189.991L276.385 189.991L276.372 189.991L276.359 189.991L276.346 189.991L276.332 189.991L276.319 189.991L276.306 189.991L276.293 189.991L276.28 189.991L276.266 189.991L276.253 189.991L276.24 189.991L276.227 189.991L276.214 189.991L276.2 189.991L276.187 189.991L276.174 189.991L276.161 189.991L276.147 189.991L276.134 189.991L276.121 189.991L276.108 189.991L276.095 189.991L276.081 189.991L276.068 189.991C274.304 189.991 273.434 189.992 272.701 190.031C258.722 190.783 247.557 201.948 246.805 215.927C246.766 216.66 246.765 217.53 246.765 219.294Z",
    stroke: "url(#paint6_linear_687_9678)",
    strokeWidth: 0.611895
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.694 129.561H238.166C229.329 129.561 222.166 136.724 222.166 145.561V155.655",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.694 245.534H238.166C229.329 245.534 222.166 238.371 222.166 229.534V219.44",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M312.673 129.561H322.202C331.038 129.561 338.202 136.724 338.202 145.561V155.655",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M312.673 245.534H322.202C331.038 245.534 338.202 238.371 338.202 229.534V219.44",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-1_687_9678",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.1 202.149H356.653V300.417H206.1V202.149Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M206.1 202.149H356.653V300.417H206.1V202.149Z",
    fill: "url(#paint7_linear_687_9678)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.1 205.149H356.653V199.149H206.1V205.149Z",
    fill: "#5283EC",
    mask: "url(#path-26-inside-1_687_9678)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_687_9678)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.976,
    y: 183.595,
    width: 84.6882,
    height: 84.6425,
    rx: 20,
    transform: "rotate(0.118781 386.976 183.595)",
    fill: "white",
    fillOpacity: 0.67,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.475,
    y: 184.096,
    width: 83.6882,
    height: 83.6425,
    rx: 19.5,
    transform: "rotate(0.118781 387.475 184.096)",
    stroke: "url(#paint8_linear_687_9678)",
    shapeRendering: "crispEdges"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M413.136 215.587C413.562 212.175 413.776 210.469 414.504 209.144C415.39 207.53 416.811 206.276 418.523 205.597C419.929 205.04 421.649 205.04 425.09 205.04H433.938C437.378 205.04 439.099 205.04 440.505 205.597C442.217 206.276 443.638 207.53 444.524 209.144C445.252 210.469 445.465 212.175 445.892 215.587C446.427 219.859 446.694 221.995 446.137 223.686C445.459 225.742 443.967 227.432 442.009 228.359C440.4 229.121 438.246 229.121 433.938 229.121H425.09C420.782 229.121 418.628 229.121 417.019 228.359C415.061 227.432 413.569 225.742 412.891 223.686C412.334 221.995 412.601 219.859 413.136 215.587Z",
    fill: "#FFE69B"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_687_9678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.42 229.118C405.42 223.342 405.42 220.454 406.404 218.191C407.603 215.436 409.802 213.238 412.558 212.041C414.823 211.057 417.712 211.057 423.491 211.057H435.538C441.317 211.057 444.206 211.057 446.471 212.041C449.227 213.238 451.426 215.436 452.625 218.191C453.609 220.454 453.609 223.342 453.609 229.118C453.609 234.894 453.609 237.781 452.625 240.045C451.426 242.799 449.227 244.998 446.471 246.195C444.206 247.179 441.317 247.179 435.538 247.179H423.491C417.712 247.179 414.823 247.179 412.558 246.195C409.802 244.998 407.603 242.799 406.404 240.045C405.42 237.781 405.42 234.894 405.42 229.118Z",
    fill: "#FFD24B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.726 229.118C405.726 226.226 405.726 224.073 405.848 222.359C405.97 220.649 406.212 219.4 406.685 218.313C407.852 215.63 409.995 213.488 412.68 212.321C413.767 211.849 415.017 211.607 416.728 211.485C418.443 211.363 420.597 211.363 423.491 211.363H435.538C438.432 211.363 440.586 211.363 442.301 211.485C444.012 211.607 445.262 211.849 446.349 212.321C449.034 213.488 451.177 215.63 452.344 218.313C452.817 219.4 453.059 220.649 453.181 222.359C453.303 224.073 453.303 226.226 453.303 229.118C453.303 232.01 453.303 234.163 453.181 235.877C453.059 237.587 452.817 238.836 452.344 239.922C451.177 242.606 449.034 244.748 446.349 245.915C445.262 246.387 444.012 246.629 442.301 246.751C440.586 246.873 438.432 246.873 435.538 246.873H423.491C420.597 246.873 418.443 246.873 416.728 246.751C415.017 246.629 413.767 246.387 412.68 245.915C409.995 244.748 407.852 242.606 406.685 239.922C406.212 238.836 405.97 237.587 405.848 235.877C405.726 234.163 405.726 232.01 405.726 229.118Z",
    stroke: "url(#paint9_linear_687_9678)",
    strokeWidth: 0.611895
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.514 222.347C425.771 222.347 422.737 225.379 422.737 229.12C422.737 232.86 425.771 235.893 429.514 235.893C433.257 235.893 436.291 232.86 436.291 229.12C436.291 225.379 433.257 222.347 429.514 222.347ZM418.22 229.12C418.22 222.885 423.276 217.832 429.514 217.832C435.752 217.832 440.808 222.885 440.808 229.12C440.808 235.354 435.752 240.408 429.514 240.408C423.276 240.408 418.22 235.354 418.22 229.12Z",
    fill: "white",
    fillOpacity: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 441.561,
    y: 217.079,
    width: 6.02365,
    height: 3.0102,
    rx: 1.5051,
    fill: "white",
    fillOpacity: 0.9
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_687_9678)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84.6882,
    height: 84.6425,
    rx: 20,
    transform: "matrix(0.999998 0.00217286 -0.00197794 0.999998 80.3018 142.268)",
    fill: "white",
    fillOpacity: 0.67,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.49901,
    y: 0.501085,
    width: 83.6882,
    height: 83.6425,
    rx: 19.5,
    transform: "matrix(0.999998 0.00217286 -0.00197794 0.999998 80.3028 142.267)",
    stroke: "url(#paint10_linear_687_9678)",
    shapeRendering: "crispEdges"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.243 195.535C128.364 193.72 139.165 187.185 139.68 168.403C139.703 167.538 139.252 166.722 138.518 166.265C128.811 160.228 116.518 160.228 106.811 166.265C106.077 166.722 105.626 167.538 105.649 168.403C106.164 187.185 116.965 193.72 121.086 195.535C122.098 195.981 123.231 195.981 124.243 195.535Z",
    fill: "#75EDA1"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_687_9678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.125 205.786C128.586 204.077 141.772 197.31 142.505 176.86C142.545 175.756 141.945 174.724 140.986 174.175C129.632 167.691 115.696 167.691 104.343 174.175C103.383 174.724 102.783 175.756 102.823 176.86C103.556 197.31 116.742 204.077 121.203 205.786C122.153 206.15 123.175 206.15 124.125 205.786Z",
    fill: "#4DC88B"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.514 180.822C133.249 181.558 133.249 182.75 132.514 183.486L122.577 193.417C122.224 193.77 121.744 193.968 121.244 193.968C120.744 193.968 120.265 193.77 119.912 193.417L114.234 187.742C113.498 187.006 113.498 185.814 114.234 185.078C114.97 184.343 116.163 184.343 116.899 185.078L121.071 189.249C121.167 189.344 121.322 189.344 121.417 189.249L129.848 180.822C130.584 180.087 131.778 180.087 132.514 180.822Z",
    fill: "url(#paint11_linear_687_9678)",
    fillOpacity: 0.9,
    stroke: "url(#paint12_linear_687_9678)",
    strokeWidth: 0.489516,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_687_9678",
    x: 302.302,
    y: 0.0768051,
    width: 220.71,
    height: 220.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_687_9678"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0846354 0 0 0 0 0.203125 0 0 0 0 0.3125 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_687_9678",
    x: 372.581,
    y: 65.6922,
    width: 64.3619,
    height: 55.8277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.15382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_687_9678",
    x: 375.798,
    y: 63.9121,
    width: 57.7169,
    height: 61.9532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.3076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_687_9678",
    x: 246.536,
    y: 131.942,
    width: 66.9439,
    height: 65.7652,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.32423
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_687_9678",
    x: 232.603,
    y: 175.829,
    width: 93.6542,
    height: 65.8691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.92831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_687_9678",
    x: 326.877,
    y: 139.672,
    width: 220.71,
    height: 220.664,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_687_9678"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0846354 0 0 0 0 0.203125 0 0 0 0 0.3125 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_687_9678",
    x: 392.363,
    y: 198,
    width: 74.303,
    height: 62.2359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.52838
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_687_9678",
    x: 20.208,
    y: 98.3481,
    width: 220.708,
    height: 220.665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_687_9678"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0846354 0 0 0 0 0.203125 0 0 0 0 0.3125 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_687_9678",
    x: 90.5137,
    y: 157.005,
    width: 64.3013,
    height: 61.3623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.15382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_687_9678"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_687_9678",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_687_9678",
    x1: 42.3441,
    y1: 0,
    x2: 42.3441,
    y2: 84.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_687_9678",
    x1: 397.333,
    y1: 66.156,
    x2: 433.422,
    y2: 73.5438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F52828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_687_9678",
    x1: 382.901,
    y1: 80.2293,
    x2: 402.923,
    y2: 119.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_687_9678",
    x1: 411.708,
    y1: 99.0325,
    x2: 419.725,
    y2: 87.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_687_9678",
    x1: 196.021,
    y1: 87.1913,
    x2: 379.315,
    y2: 271.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_687_9678",
    x1: 259.184,
    y1: 152.178,
    x2: 278.367,
    y2: 184.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_687_9678",
    x1: 249.551,
    y1: 193.078,
    x2: 314.386,
    y2: 223.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_687_9678",
    x1: 281.376,
    y1: 202.149,
    x2: 281.376,
    y2: 300.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CFF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_687_9678",
    x1: 429.32,
    y1: 183.595,
    x2: 429.32,
    y2: 268.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_687_9678",
    x1: 401.977,
    y1: 214.341,
    x2: 460.472,
    y2: 254.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_687_9678",
    x1: 42.3441,
    y1: 0,
    x2: 42.3441,
    y2: 84.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_687_9678",
    x1: 116.543,
    y1: 185.435,
    x2: 147.595,
    y2: 189.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_687_9678",
    x1: 114.002,
    y1: 182.049,
    x2: 126.704,
    y2: 186.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMainFrame);
export default __webpack_public_path__ + "static/media/login-main-frame.b955d7871e77b48e197a6d2b135c8c28.svg";
export { ForwardRef as ReactComponent };